import React, { useEffect, useState, useRef } from 'react';
import {
    DialogTitle, DialogContent, DialogActions, Dialog, makeStyles, Paper, ClickAwayListener, MenuList, MenuItem, Card, CardContent,
    Divider,
    Popper,
    Grow
} from '@material-ui/core';
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const useStyles = makeStyles((theme) => ({
    filterButton: {
        backgroundColor: "#fff",
        // margin: "0 3px",
        borderRadius: 30,
        textTransform: "capitalize",
        padding: "5px 10px"
    },
    arrowDropDownIconV1: {
        marginTop: -3
    },
    wV1: {
        width: '100%'
    },
    menuItemV1: {
        display: 'flex', justifyContent: 'center', fontWeight: 300, paddingTop: 10, paddingBottom: 10
    },
}));

const DocumentBookPdfFilter = ({ pdfFilterValueFromReports, defaultFilterValueFromReports, onSelect }) => {

    const [selectedFilterValue, setSelectedFilterValue] = useState(defaultFilterValueFromReports ? defaultFilterValueFromReports : "");
    const [open, setOpen] = useState(false);

    const anchorRef = React.useRef(null);
    const prevOpen = React.useRef(open);

    const classes = useStyles();

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, []);

    const handleFilterClickOpen = () => {
        setOpen(true);
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    }

    const handleItemClick = (value) => {
        onSelect(value);
        setSelectedFilterValue(pdfFilterValueFromReports[value]);
        setOpen(false);
    }

    return (
        <>
            <div>
                <Button
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    variant="outlined"
                    size="small"
                    className={classes.filterButton}
                    onClick={handleFilterClickOpen}
                >

                    <span>{selectedFilterValue ? selectedFilterValue : ""}</span>

                    <ArrowDropDownIcon className={classes.arrowDropDownIconV1} />
                </Button>
            </div>

            {open &&

                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1000 }}>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper className={classes.paper1}>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList autoFocusItem={open} id="menu-list-grow">

                                        {Object.keys(pdfFilterValueFromReports).map((doc, index) => (
                                            <div className={classes.wV1} key={index}>
                                                <div className={classes.wV1} >
                                                    <MenuItem key={pdfFilterValueFromReports[doc]} className={classes.menuItemV1} onClick={() => handleItemClick(doc)}>{pdfFilterValueFromReports[doc]}</MenuItem>
                                                    <Divider light />
                                                </div>
                                            </div>
                                        ))}

                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            }
        </>
    )

}

export default DocumentBookPdfFilter;